/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Chat_Daily_Limit_Description_AtInputs */



/**
* | output |
* | --- |
* | "You've used today's AI allowance. It resets at {time}. Upgrade for unlimited usage." |
*
* @param {Chat_Daily_Limit_Description_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_daily_limit_description_at = /** @type {((inputs: Chat_Daily_Limit_Description_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Daily_Limit_Description_AtInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du hast das heutige KI-Guthaben verbraucht. Reset um ${i?.time}. Upgrade für unbegrenzte Nutzung.`)
	return /** @type {LocalizedString} */ (`You've used today's AI allowance. It resets at ${i?.time}. Upgrade for unlimited usage.`)
});